<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="750"
    scrollable
  >
    <v-card>
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find(
            (oc) => oc.rota == '/instalacoes'
          )
        "
      />
      <v-card-text :class="{ 'pb-10': isMobile() }">
        <v-row :dense="isMobile()" class="mt-6">
          <v-col md="6" cols="12">
            <v-text-field
              label="Temperatura ambiente (°C)"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.temperatura_ambiente"
              suffix="°C"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Umidade do ar"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.umidade_ar"
              suffix="%"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Ventiladores"
              outlined
              rows="5"
              placeholder="Ex.: quantidade, funcionamento, falhas, manutenção, eficiência do ar."
              persistent-placeholder
              v-model="visita.obs_ventiladores"
              auto-grow              
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-row dense>
              <v-col cols="12">
                <h2>Cochos</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <slider-imagens-visita                  
                  categoria="cochos"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  class="mt-1"
                  label="Observações cochos"
                  outlined
                  rows="5"
                  placeholder="Ex.: sobra de alimento, limpeza, acesso dos animais, condições do cocho."
                  persistent-placeholder
                  v-model="visita.obs_cochos"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import SliderImagensVisita from "./SliderImagensVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita, SliderImagensVisita },
  computed: mapState("visitaTecnica", ["visita","configuracoes"]),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>